
  import ScreenSize from '@/mixins/ScreenSize';
  import countTestimonials from '@/apollo/queries/testimonial/countTestimonials.gql';
  import getTestimonials from '@/apollo/queries/testimonial/getTestimonials.gql';
  import Pagination from '@/components/Pagination';
  export default {
    name: 'SectionTestimonialListing',
    components: {
      Pagination,
      TestimonialCard: () => import('@/components/TestimonialCard'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        page: 1,
        countPages: 0,
        itemsPerPage: this.section.num_testimonials,
        orderBy: 'date:desc',
        testimonials: [],
        testimonialsCount: 0,
      };
    },
    watch: {
      '$route.query': function () {
        this.parsePageFromQuery();
      },
    },
    apollo: {
      testimonials: {
        query: getTestimonials,
        variables() {
          this.parsePageFromQuery();

          return {
            sort: this.orderBy,
            limit: this.itemsPerPage,
            start: this.itemsPerPage * (this.page - 1),
            search_term: '',
            search_type: this.section.type ? this.section.type : '',
          };
        },
      },
      testimonialsCount: {
        query: countTestimonials,
        variables() {
          return {
            search_term: '',
            search_type: this.section.type ? this.section.type : '',
          };
        },
        result({data}) {
          const testimonialCount = data.testimonialsCount.aggregate.count;
          this.countPages = Math.ceil(testimonialCount / this.itemsPerPage);
        },
      },
    },
    methods: {
      parsePageFromQuery() {
        this.page = this.$route.query.page
          ? parseInt(this.$route.query.page)
          : 1;
      },
      pushRouter() {
        this.$router.push(this.localePath({}) + `?page=${this.page}`);
      },
    },
  };
